import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import progressBar from '../../assets/polls/progress_bar.svg';
import "./AnswerPoll.css";
import AnswerForm from './AnswerForm';
import * as firebase from 'firebase';
import { DisplayStats } from './DisplayStatsAnswers';
import Tooltip from '@material-ui/core/Tooltip';
import editImage from '../../assets/pencil.svg';
import EditPoll from './EditPoll';
import Modal from "react-responsive-modal";
class AnswerPollContent extends Component {

    render() {
        return (
            <AnswerPollForm
                onClose={this.props.onClose}
                activePollID={this.props.activePollID}
                activeCapsuleID={this.props.activeCapsuleID}
                markPollAsAnswered={this.props.markPollAsAnswered}
                answerStep={this.props.answerStep} />
        );
    }
}

const INITIAL_STATE = {
    question: '',
    answers: {},
    selectedAnswer: '',
    poll: {},
    error: null,
    currentUserId: '',
    openEdit: false,
};

class AnswerPollFormBase extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...INITIAL_STATE,
            currentState: this.props.answerStep || 'STEP1'
        };
    }

    componentDidMount = async () => {
        this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

            if (currentUser === null) {
                return
            }
            let activePollID = this.props.activePollID;
            let activeCapsuleID = this.props.activeCapsuleID;
            let poll = await this.props.firebase.db.collection('capsules').doc(activeCapsuleID).collection('polls').doc(activePollID).get()


            this.setState({
                poll: poll.data(),
                question: poll.data().question,
                answers: poll.data().answers,
                creationDate: poll.data().creationDate,
                currentUserId: currentUser.uid,
            })
        })
    }

    onSubmitAnswer = async event => {
        event.preventDefault();
        this.setState({ currentState: "STEP2" });

        let activePollID = this.props.activePollID;
        let activeCapsuleID = this.props.activeCapsuleID;
        let answer = {
            answer: this.state.selectedAnswer,
            userId: this.props.firebase.auth.currentUser.uid
        }

        await this.props.firebase.db.collection('capsules')
            .doc(activeCapsuleID)
            .collection('polls')
            .doc(activePollID)
            .collection('userAnswers')
            .add(answer)

        await this.props.firebase.db.collection('capsules')
            .doc(activeCapsuleID)
            .collection('polls')
            .doc(activePollID)
            .update({
                collectedUsers: firebase.firestore.FieldValue.arrayUnion(this.props.firebase.auth.currentUser.uid)
            })

        this.props.markPollAsAnswered(activePollID);

    };

    onPollAnswer = event => {
        this.setState({
            selectedAnswer: event.target.value
        });
    }

    openEdit = () => {
        this.setState({
            openEdit: true
        })
    }

    closeEdit = () => {
        this.setState({
            openEdit: false
        })
        this.props.onClose()
    }

    render() {
        const {
            question,
            error,
            answers,
            selectedAnswer,
            currentState,
            creationDate,
            poll,
            currentUserId } = this.state;

        return (

            <>
                {currentState === 'STEP1' ?
                    <form onSubmit={this.onSubmitAnswer}>
                        <div className="answer-poll-container">

                            <div className="answer-poll-header">
                                <img className="answer-poll-bar" src={progressBar} alt="Answer" />
                            </div>
                            <div className={window.innerWidth > 768 ? "answer-body-desktop" : "answer-body-mobile"}>
                                <Tooltip title="Editer" aria-label="editer" hidden={poll.creatorId !== currentUserId} className={window.innerWidth > 768 ? "edit-poll-desktop" : "edit-poll-mobile"}>
                                    <img src={editImage} alt="edit" className="edit-icon cursor-pointer" onClick={this.openEdit}></img>
                                </Tooltip>
                                <div className="answer-poll-title">{question}</div>
                                <div className="answer-line-mobile" hidden={window.innerWidth > 768}></div>



                                <div className="answer-poll-form-container-mobile">

                                    <AnswerForm
                                        answers={answers}
                                        handleChange={this.onPollAnswer} />

                                    {error && <p>{error.message}</p>}

                                </div>
                            </div>
                        </div>

                        <button type="submit" disabled={selectedAnswer.length === 0} className="answer-poll-button">Suivant</button>
                    </form> :
                    <DisplayStats
                        onClose={this.props.onClose}
                        openEdit={this.openEdit}
                        question={question}
                        answers={answers}
                        creationDate={creationDate}
                        activePollID={this.props.activePollID}
                        poll={poll}
                        activeCapsuleID={this.props.activeCapsuleID}
                        date={new Date()} />
                }
                <Modal
                    open={this.state.openEdit}
                    onClose={this.closeEdit}
                    center
                    showCloseIcon={true}
                    styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
                >
                    <EditPoll
                        onClose={this.closeEdit}
                        poll={poll}
                        pollId={this.props.activePollID}
                        capsuleId={this.props.activeCapsuleID} />
                </Modal>
            </>
        );
    }
}

const styles_desktop = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "601px",
        maxWidth: "395px",
        top: "10%",
        padding: "0px",
    }
};

const styles_mobile = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        boxShadow: 'none',
        minHeight: "100%",
        width: "100%",
        padding: "0px",
    }
};


const AnswerPollForm = withRouter(withFirebase(AnswerPollFormBase));


export { AnswerPollContent };
export default AnswerPollForm;
